"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Header = styled_components_1.default.h4 `
  font-size: 28px;
  margin: 0;
  color: #000;
  padding: 0 1rem;
  line-height: 32px;
  background-color: white;
  font-weight: 500;
`;
const ListHeader = ({ text }) => {
    return react_1.default.createElement(Header, null, text);
};
exports.default = ListHeader;
